import { render, staticRenderFns } from "./MyApps.vue?vue&type=template&id=d850634c&scoped=true&"
import script from "./MyApps.vue?vue&type=script&lang=js&"
export * from "./MyApps.vue?vue&type=script&lang=js&"
import style0 from "./status.scss?vue&type=style&index=0&id=d850634c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850634c",
  null
  
)

export default component.exports